export const initialEventData = {
	title: "",
	date: "",
	startTime: "",
	endTime: "",
	imageUrl: "",
	image: null,
	name: "",
	address: "",
	lat: null,
	lng: null,
	details: "",
	placeId: "",
	staticMapUrl: "",
};

export const formatDateLongEuropean = (dateString) => {
	if (!dateString) return "";
	const date = new Date(dateString);
	return date.toLocaleDateString("en-GB", {
		weekday: "long", // Saturday
		day: "2-digit", // 08
		month: "long", // August
		year: "numeric", // 2000
	});
};

export const formatEventDateTime = (date, time) => {
	const eventDateTime = new Date(`${date}T${time}`);
	return new Intl.DateTimeFormat("en-US", {
		weekday: "short", // MON
		month: "short", // AUG
		day: "numeric", // 4
		hour: "2-digit", // 14
		minute: "2-digit", // 00
		hour12: false, // 24-hour format
	}).format(eventDateTime);
};

export const truncateTitle = (title) => {
	if (!title) return "";

	const isMobile = window.innerWidth < 576; // Bootstrap 'sm' breakpoint
	const maxLength = isMobile ? 75 : 94;

	return title.length > maxLength ? title.slice(0, maxLength) + "..." : title;
};
